import React from "react";

import type { Orientation } from "@busbud/design-system-components/dist/SeatBase";
import type { Choices } from "@busbud/int-schemas/lib";
import type * as UDM from "@busbud/int-schemas/udm";

import { useAppContext } from "@app/helpers/hooks";
import { findActiveSeat } from "@app/helpers/udm/vehicle";

import { BusHorizontal } from "./bus-horizontal";
import { BusVertical } from "./bus-vertical";
import { useStyles } from "./bus.styles";
import { clickedSeat } from "../../../tracking/checkout-tracking";

export type BusProps = {
  vehicle_layout: UDM.Bus["layout"];
  vehicle_driver: UDM.Bus["driver"];
  already_assigned_seat_ids: (string | null)[];
  active_seat_id: string | null;
  onSeatChange: (seat: UDM.SeatCell) => void;
  onGenderChange?: (gender: Choices.Gender) => void;
  orientation?: Orientation;
  is_checkout?: boolean;
  active_floor: number;
  seatClassResolver?: (seat_id: string) => string | null;
};

export const Bus: React.FC<BusProps> = props => {
  const { tracker } = useAppContext();
  const {
    vehicle_layout,
    vehicle_driver,
    active_seat_id,
    already_assigned_seat_ids,
    onSeatChange,
    onGenderChange,
    orientation = "top",
    is_checkout,
    active_floor,
    seatClassResolver
  } = props;
  const { cx, classes } = useStyles();

  const floor = vehicle_layout![active_floor];
  // @ts-expect-error TS2345 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  const active_seat = findActiveSeat(floor, active_seat_id);

  function handleSeatChange(seat: UDM.SeatCell) {
    tracker.track(clickedSeat(seat.id));
    onSeatChange(seat);
  }

  const bus_props = {
    active_seat,
    active_floor,
    onGenderChange,
    onSeatChange: handleSeatChange,
    vehicle_layout,
    vehicle_driver,
    active_seat_id,
    already_assigned_seat_ids,
    is_checkout,
    seatClassResolver
  };

  const OrientedBus = orientation === "left" ? BusHorizontal : BusVertical;

  return (
    <div
      data-testid="default-bus"
      className={cx(classes.layout, classes[orientation])}
    >
      <OrientedBus {...bus_props} />
    </div>
  );
};
